import { createFileRoute } from "@tanstack/react-router";
import { TopicPage } from "@/components/site/TopicPage";
import logoAsset from "@/assets/lifewestway-logo.png.asset.json";
import { makeSeoDescription } from "@/lib/seo-description";

const SITE = "https://lifewestway.com";
const TITLE = "Verified Jobs Abroad 2026 | LifeWestWay";
const DESC = "Verified part-time, full-time and remote job listings across USA, UK, Australia, Italy, Portugal, and Canada.";
const URL_ = `${SITE}/jobs`;
const IMAGE = `${SITE}${logoAsset.url}`;

export const Route = createFileRoute("/jobs")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: makeSeoDescription(DESC) },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: makeSeoDescription(DESC) },
      { property: "og:type", content: "article" },
      { property: "og:url", content: URL_ },
      { property: "og:image", content: IMAGE },
      { property: "og:image:alt", content: "LifeWestWay" },
      { property: "og:site_name", content: "LifeWestWay" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: makeSeoDescription(DESC) },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: "https://lifewestway.com/jobs" }],
  }),
  component: () => (
    <TopicPage
      topic="Jobs"
      intro="Verified full-time, part-time, and remote listings from employers who genuinely hire international talent."
    />
  ),
});
